import { Component, inject } from '@angular/core';
import { SettingsService } from '../../shared/settings/settings.service';
import { ViewModelProperty } from '@ldw/roesberg';
import { InfoService } from '../../shared/services/info.service';
import { UserInformationService } from '../user-information.service';
import { Observable } from 'rxjs';
import { LdwRouterService } from '../../route/ldw-router.service';

@Component({
    selector: 'ldw-settings-page',
    templateUrl: './settings-page.component.html',
    styleUrls: ['./settings-page.component.css'],
    standalone: false
})
export class SettingsPageComponent {
  private settingsService = inject(SettingsService);
  private userInfoService = inject(UserInformationService);
  private routerService = inject(LdwRouterService);
  private infoService = inject(InfoService);

  settings: Array<Array<ViewModelProperty>>;

  canChangePassword$: Observable<boolean>;

  constructor() {
    const settingsService = this.settingsService;

    this.settings = settingsService.settings.visibleSettings;
    this.infoService.clearStatus();
    this.canChangePassword$ = this.userInfoService.canChangePassword$;
  }

  goToChangePassword() {
    this.routerService.navigateToPasswordChange();
  }
}
